import React from 'react';
import { TopBar } from '../components/sections/TopBar';
import { Hero } from '../components/sections/Hero';
import { TrustSection } from '../components/sections/TrustSection';
import { Problem } from '../components/sections/Problem';
import { Benefits } from '../components/sections/Benefits';
import { Breakdown } from '../components/sections/Breakdown';
import { Bonuses } from '../components/sections/Bonuses';
import { Testimonials } from '../components/sections/Testimonials';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { StickyBottomBar } from '../components/ui/StickyBottomBar';
export function LandingPage() {
  return <main className="min-h-screen w-full flex flex-col font-sans text-brand-dark" data-id="element-347">
      <TopBar data-id="element-348" />
      <Hero data-id="element-349" />
      <Offer data-id="element-350" />
      <Guarantee data-id="element-351" />
      <TrustSection data-id="element-352" />
      <Problem data-id="element-353" />
      <Benefits data-id="element-354" />
      <Breakdown data-id="element-355" />
      <Bonuses data-id="element-356" />
      <Testimonials data-id="element-357" />
      <FAQ data-id="element-358" />
      <FinalCTA data-id="element-359" />

      <StickyBottomBar data-id="element-360" />

      <footer className="bg-brand-dark text-white/60 py-8 text-center text-sm" data-id="element-361">
        <div className="container mx-auto px-4" data-id="element-362">
          <p data-id="element-363">
            © {new Date().getFullYear()} Viaje a tu Interior. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}